module.exports = __webpack_public_path__ + "img/downloadddd2.a4b22371.png";